import React from "react";
const HorizontalRule = () => {
  return <div className={"hr"} />;
};

export default HorizontalRule;
